var engineIsBrowser = typeof window == 'object';

export { engineIsBrowser as default };
